import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent} from "@wms/components";
import {FormsModule} from "@angular/forms";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {ColorIconDirective, WMSColorpickerComponent} from "@wms/properties-panel";
import {ColorPickerModule} from "ngx-color-picker";

@Component({
  selector: 'wms-style',
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, WMSColorpickerComponent, ColorPickerModule, ColorIconDirective],
  templateUrl: './style.component.html',
  styleUrls: ['./style.component.less']
})
export class StyleComponent extends BaseComponent{

  @Input() liveWidgetSettingsService: any;

  constructor() {
    super();
  }
  onChange($event : any) : void {
    this.liveWidgetSettingsService.selectedComponent.field.backgroundColor = $event;
  }
}
